import React from "react";
import { Container } from "react-bootstrap";
import styles from "./LogoMarquee.module.css";

export default function LogoMarquee({ logos = [] }) {
  if (!logos || logos.length === 0) return null;

  return (
    <div className={styles.marqueeWrapper}>
      <Container>

        {/* Heading */}
        <div className={styles.headingWrapper}>
          <h2 className={styles.heading}>Our Trusted Partners</h2>
          <div className={styles.headingLine}></div>
        </div>

        {/* Marquee */}
        <div className={styles.marquee}>
          <div className={styles.marqueeTrack}>
            {[...logos, ...logos].map((logo, index) => (
              <div key={index} className={styles.logoCircle}>
                <img
                  src={`${logo?.img}`}
                  alt="logo"
                  className={styles.logoImg}
                />
              </div>
            ))}
          </div>
        </div>

      </Container>
    </div>
  );
}
